import React, { useState } from 'react';

import SvgArrowDown from '@sats-group/icons/16/arrow-down';
import SvgArrowUp from '@sats-group/icons/16/arrow-up';
import Button from '@sats-group/ui-lib/react/button';
import Collapse from '@sats-group/ui-lib/react/collapse';
import LinkCard from '@sats-group/ui-lib/react/link-card';
import Text from '@sats-group/ui-lib/react/text';

import type { CampaignBanner as Props } from './campaign-banner.props';

const CampaignBanner: React.FC<Props> = ({
  availableCampaigns,
  availableCampaignsLabel,
  label,
  seeMore,
  title,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="campaign-banner">
      <div className="campaign-banner__header">
        <div className="campaign-banner__descriptions">
          <div className="campaign-banner__label">
            <Text theme={Text.themes.headline} italic>
              {label}
            </Text>
          </div>
          <div className="campaign-banner__title">
            <Text theme={Text.themes.emphasis}>{title}</Text>
          </div>
        </div>
        {availableCampaigns.length ? (
          <div className="campaign-banner__trigger">
            <Button
              aria-expanded={isOpen}
              trailingIcon={isOpen ? <SvgArrowUp /> : <SvgArrowDown />}
              onClick={() => setIsOpen(isOpen => !isOpen)}
              size={Button.sizes.small}
              text={seeMore}
              variant={Button.variants.secondaryWhite}
            />
          </div>
        ) : null}
      </div>

      {availableCampaigns.length ? (
        <Collapse isOpen={isOpen} duration={200}>
          <div className="campaign-banner__available-campaigns">
            <div className="campaign-banner__available-campaigns-label">
              <hr className="campaign-banner__divider" />
              <Text theme={Text.themes.emphasis} size={Text.sizes.large}>
                {availableCampaignsLabel}
              </Text>
            </div>
            {availableCampaigns.map(campaign => (
              <div
                key={campaign.title}
                className="campaign-banner__available-campaigns-item"
              >
                <LinkCard {...campaign} />
              </div>
            ))}
          </div>
        </Collapse>
      ) : null}
    </div>
  );
};

export default CampaignBanner;
